/*
  National page pricing hierarchy.

  The pricing box on /pages/<handle>-national is part of the page's stored
  content and is filled in by that page's own script, which fetches the live
  price and destination from the national pricing API. This file waits for those
  values, then:

    - moves the "Current Price" caption below the amount as a secondary label,
    - adds a Destination / Vehicle Total summary in the site's pricing style,
      where Vehicle Total = current price + destination.

  It reads the values the page already displays; it never fetches pricing itself,
  never hard-codes an amount, and adds nothing to the shipping estimator below.
  When there is no usable destination (including used units, which have none),
  the original presentation is left exactly as it was.

  Works with both generated markup variants because it keys on the element IDs
  they share: poway-price-wrap, poway-live-price, poway-destination-row,
  poway-destination-amount.
*/
(function () {
  var wrap = document.getElementById('poway-price-wrap');
  if (!wrap) return;

  var priceEl = document.getElementById('poway-live-price');
  var destRow = document.getElementById('poway-destination-row');
  var destAmountEl = document.getElementById('poway-destination-amount');
  if (!priceEl || !destRow || !destAmountEl) return;

  var SUMMARY_ID = 'poway-national-summary';

  function toNumber(text) {
    var cleaned = String(text == null ? '' : text).replace(/[^0-9.]/g, '');
    if (!/\d/.test(cleaned)) return NaN;
    var value = parseFloat(cleaned);
    return isFinite(value) ? value : NaN;
  }

  function money(value) {
    return (Math.round(value * 100) / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // "Current Price" caption sits above the amount; it becomes the label below it.
  function moveCaption() {
    if (wrap.dataset.pnpCaption === '1') return;

    var card = wrap.parentElement;
    if (!card) return;

    var caption = null;
    var children = card.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === wrap) break;
      if (el.id) continue;
      var text = (el.textContent || '').trim();
      if (text && text.length < 40) caption = el;
    }
    if (!caption) return;

    var priceRow = priceEl.parentElement || priceEl;
    var label = document.createElement('div');
    label.className = 'pnp-label';
    label.textContent = (caption.textContent || 'Current Price').trim().toUpperCase();

    caption.style.display = 'none';
    priceRow.insertAdjacentElement('afterend', label);
    wrap.dataset.pnpCaption = '1';
  }

  function renderSummary(destination, total) {
    var summary = document.getElementById(SUMMARY_ID);
    if (!summary) {
      summary = document.createElement('div');
      summary.id = SUMMARY_ID;
      summary.className = 'pnp-summary';

      // Sits directly under the price, above the "No Dealer Setup" bar.
      var anchor = null;
      var blocks = wrap.children;
      for (var i = 0; i < blocks.length; i++) {
        if (/no dealer setup/i.test(blocks[i].textContent || '')) {
          anchor = blocks[i];
          break;
        }
      }
      if (anchor) wrap.insertBefore(summary, anchor);
      else wrap.appendChild(summary);
    }

    summary.innerHTML =
      '<p class="pnp-summary__dest">' +
        '<span class="pnp-summary__dest-label">Destination:</span> ' +
        '<span class="pnp-summary__dest-amount"></span>' +
      '</p>' +
      '<div class="pnp-summary__total">' +
        '<span class="pnp-summary__total-label">Vehicle Total:</span>' +
        '<span class="pnp-summary__total-amount"></span>' +
        '<span class="pnp-summary__note">Before tax, DMV &amp; doc fee.</span>' +
      '</div>';

    summary.querySelector('.pnp-summary__dest-amount').textContent = money(destination);
    summary.querySelector('.pnp-summary__total-amount').textContent = money(total);
  }

  function removeSummary() {
    var summary = document.getElementById(SUMMARY_ID);
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
  }

  function apply() {
    // The page hides the box until its pricing request succeeds.
    if (!wrap.offsetParent && wrap.style.display === 'none') return false;

    var price = toNumber(priceEl.textContent);
    if (!(price > 0)) return false;

    var destination = toNumber(destAmountEl.textContent);

    moveCaption();
    wrap.classList.add('pnp-on');

    if (destination > 0) {
      // Vehicle Total is price + destination only: no shipping, tax, DMV or doc fee.
      destRow.style.display = 'none';
      renderSummary(destination, price + destination);
    } else {
      // No usable destination: leave the original presentation untouched.
      removeSummary();
      destRow.style.display = '';
    }

    return true;
  }

  function start() {
    if (apply()) return;

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (apply() || attempts > 75) clearInterval(timer);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
